"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fetchClient = require("@nike/fetch-client");
var _makeQueryKey = _interopRequireDefault(require("../../../../utils/make-query-key"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getFetchDesignViewsOptions = function getFetchDesignViewsOptions(_ref) {
  var designViewId = _ref.designViewId;
  return {
    queryKey: (0, _makeQueryKey["default"])(['design_views/v1', {
      designViewId: designViewId
    }]),
    queryFn: function queryFn() {
      return (0, _fetchClient.fetchClient)("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/customization/design_views/v1/").concat(designViewId));
    }
  };
};
var _default = exports["default"] = getFetchDesignViewsOptions;